import React from "react";

export default function Contact() {
  return (
    <div className="card">
      <div className="card-body">Contact: support@shls.care</div>
    </div>
  );
}
